export const PRICING_PLAN_TIERS = {
  HOBBY: 'HOBBY',
  PRO_MONTHLY: 'PRO_MONTHLY',
  PRO_YEARLY: 'PRO_YEARLY',
  BUSINESS: 'BUSINESS',
  ENTERPRISE: 'ENTERPRISE',
} as const

/**
 * Consumer Pro amounts shown on /packs and landing — must match Stripe Price
 * amounts (Zporti Pro Monthly / Yearly).
 */
export const CONSUMER_PRO_DISPLAY_PRICES = {
  MONTHLY_LABEL: '$7.90',
  MONTHLY_SUB: 'per month',
  YEARLY_LABEL: '$59.90',
  YEARLY_SUB: 'per year',
} as const

export function isConsumerProPricingPlanTier(tier: string): boolean {
  return tier === PRICING_PLAN_TIERS.PRO_MONTHLY || tier === PRICING_PLAN_TIERS.PRO_YEARLY
}
